import { FC, Children,KeyboardEvent, ReactElement, isValidElement, useContext, useEffect, useMemo, useState, useRef } from 'react';
import { Container, Dimmer, Loader, Segment, Checkbox, Form, Modal } from 'semantic-ui-react';
import { List, ModalProps, Button, Message, TableProps as TableImplProps, Accordion} from 'semantic-ui-react';
import { EfsFile } from '../api/files';
import { useApi, api } from '../api/api';
import { ActionAccess } from '../api/base';
import { Request } from '../api/requests';
import { AuthContext, ROLES } from '../components/Authentication';
import { SyncButton, FilterButton } from '../components/buttons';
import MessageWindow from '../components/MessageWindow';
import Uploader, { UploaderProps } from '../components/Uploader';
import IOApiTable, { IOApiTableActions } from '../components/IOApiTable';
import Table, { ButtonCell, TextCell } from '../components/Table';
import SqlFiltersWindow from '../components/SqlFiltersWindow'
import { StatisticsEvent, StatisticsField, statisticsFields, StatisticsFilter } from '../api/statistics';
import FilterSettings from './Events/FilterSettings';
import { Input, Icon, Dropdown, Popup } from 'semantic-ui-react';
import Pagination from '../components/Pagination';
import FileChunkWindow from "../components/FileChunkWindow";
import {ApiFileChunk} from "../api/io";
import { envColor } from '../common';


const PAGE_SIZE = 15;


const Statistics: FC = (props) => {
    const statisticsApi = useApi(api.statistics);
    const sqlApi = useApi(api.sqlFilters)
    const bucketApi = useApi(api.bucket);

    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState(false);

    const [filtersModal, setFiltersModal] = useState(false);

    const [events, setEvents] = useState<StatisticsEvent[]>([]);
    const [fileLoading, setFileLoading] = useState(false);

    const [activePage, setActivePageImpl] = useState<number>(1);
    const activePageRef = useRef<number>(activePage);
    const [totalPages, setTotalPages] = useState(1);

    const [filterOptions, setFilterOptions] = useState<StatisticsFilter>([]);
    const filterRef = useRef<StatisticsFilter>([]);
    const [filter, setFilterImpl] = useState<StatisticsFilter>(filterRef.current);

    const [currentFileChunk, setFileChunk] = useState<ApiFileChunk>();
    const [currentAlert, setAlert] = useState('');

    const setFilter = (newFilter: StatisticsFilter) => {
        filterRef.current = newFilter;
    };

    const setActivePage = (newPage: number) => {
        activePageRef.current = newPage;
        setActivePageImpl(newPage);
        load();
    };

    const urlDownload = (url: string) => {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', url);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
    };

    const bucketDownload = (url: string, index: number = 1) => {
        if (url == null || url === "None") {
            setAlert("Requested resource doesn't exist");
        }
        else {
            setFileLoading(true);
            bucketApi
                .read_chunk(url, index)
                .then(setFileChunk)
                .catch(() => { setAlert(`Requested resource doesn't exist : "${url}"`); })
                .finally(() => setFileLoading(false))
        }
    };


    const load = async () => {
        setLoading(true);

        return statisticsApi
            .index(
            filterRef.current,
            activePageRef.current,
            PAGE_SIZE,
            )
            .then(({ items, count }) => {
                setEvents(items);
                setTotalPages(Math.ceil(count / PAGE_SIZE))
            })
            .catch(e => console.error(e))
            .finally(()=>setLoading(false));
    }

    const setSqlMenu = async () => {
        if (filtersModal){
            setFiltersModal(false)
        }
        else{
            setFiltersModal(true)
        }
    }

    const get_cells = () => {
        const text = (header: string, value: (data: StatisticsEvent) => any) => (
            <TextCell {...{header, value}} />
        );

        const popupForOutput = (json_output: string) => {
            let popupValue = json_output.split('/').slice(-1)[0]
            let button = <ButtonCell
             style={{display: 'inline', background:'white'}}
             header=''
             value={() => json_output}
             icon='arrow down'
             onClick={bucketDownload}
             color={envColor} />

            if (popupValue==='None'){
                button = <ButtonCell
                 disabled
                 button={{ color: 'grey' }}
                 style={{display: 'inline', background:'white'}}
                 header='' value={() => json_output}
                 icon='arrow down'
                 color={envColor} />
            }

            return <Popup content={popupValue} trigger={button}/>
        }

        const outputCell = (
            <TextCell header='output' value={e => popupForOutput(e.json_output)}/>
        );

        const cellDefinitions: Record<StatisticsField, ReactElement> = {
            objectId: text('objectId', e => e.objectId),
            sic: text('sic', e => e.sic),
            source: text('source', e => e.source),
            content_type: text('content_type', e => e.content_type),
            json_output: outputCell,
            processing_type: text('processing_type', e => e.processing_type),
            process_time: text('process_time', e => e.process_time),
            res: text('res', e => e.res),
        };

        const cells = Object
            .keys(cellDefinitions)
            .map(key => cellDefinitions[key as StatisticsField]);

        return Children.toArray(cells);

    };

    const apply = (f?: any) => {
        load()
    };

    const keyPress = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            apply();
        }
    };

    const clear = (key?: string) => {
        return setFilter([]);
    }

    const onFieldChange = (id: StatisticsField, value?: any) => {
        if (value){
            value = value.replace(/\s+/g,' ')
            const clauses = value.split(' AND ')
            let newFilter: StatisticsFilter = []

            if (clauses.length === 1){
                let operator = '='
                if (value.includes('%')){
                    operator='LIKE'
                }
    //         check if we need to use LIKE of Equal
                let tmp = clauses[0].split(' ')
                if (tmp.length === 1){
                    return setFilter([{field: id, operator: operator, value: value}])
                }
                else{

                    let [id, operator, ...value] = clauses[0].split(' ')
                    value = value.join(' ')
                    return setFilter([{field: id, operator: operator, value: value}])
                }
                return setFilter([{field: id, operator: operator, value: value}])
            }

            for (var clause of clauses ){
                let [id, operator, ...value] = clause.split(' ')
                value = value.join(' ')
                newFilter.push({field: id, operator: operator, value: value})
            }
            return setFilter(newFilter)
        }
        else{
            return clear();
        }

    };

    const onFormChange = () => {
        if (form){
            setForm(false)
        }
        else {
            setForm(true)
        }
    }

    const forceFilterRead = async (id: StatisticsField, value: any) => {
        let textField = document.getElementById("objectId") as HTMLInputElement;
        if (value.isTrusted == false){
            onFieldChange(id, textField.value)
        }
    }

    const onFC = (value?: any) => {
        let textField = document.getElementById("objectId") as HTMLInputElement;
        if (textField !== null ) {
            setLoading(true);

            if (filtersModal){
                textField.value = value
                setSqlMenu()
            }
            textField.click()
            setLoading(false);
        }
    }


    const renderForm = () => {
        let sqlData = ''
        let sqlTag = ''

        const onAdd = async () => {
            setLoading(true)
            setForm(false)
            setFiltersModal(false)
            return sqlApi
            .write(
            {sql_query: sqlData, tag: sqlTag},
            )
            .then(() => {})
            .catch(e => console.error(e))
            .finally(()=>setLoading(false));
        }


        const onFormFieldChange = (type: string, change_string: any) => {
            if (type==='sql'){
                sqlData=change_string
            }
            else{
                sqlTag=change_string
            }
        }

        const form =
        <Modal
            size='large'
            style={{ minWidth: '70%', maxWidth: '95%' }}
            closeIcon
            open={true}
            onClose={onFormChange}
        >
        <Modal.Header>Add filter</Modal.Header>
        <Modal.Content scrolling>

            <Form>
            <Form.Field required>
              <label>SQL query</label>
              <input placeholder='Your SQL filter' onChange={({ target: { value } }) => onFormFieldChange('sql', value)}/>
            </Form.Field>
            <Form.Field>
              <label>Tag [Optional] </label>
              <input placeholder='Name for the filter' onChange={({ target: { value } }) => onFormFieldChange('tag', value)} />
            </Form.Field>
            <Button
            type='submit'
            onClick={onAdd}>
            Submit
            </Button>
          </Form>

        </Modal.Content>

        <Modal.Actions>
            <Button circular onClick={onFormChange}>
            Close
            </Button>
        </Modal.Actions>

        </Modal>

      return form
    }

    return (
    <div>
            <Dimmer active={fileLoading}><Loader/></Dimmer>

            {currentFileChunk &&
                <FileChunkWindow
                    file={currentFileChunk}
                    onClose={() => setFileChunk(undefined)}
                    filePageChange={bucketDownload}
                    loading={fileLoading}
                    saveFile={urlDownload}
                />
            }


            <Segment style={{ margin: '50px 25px 0 50px' }}>
                <Container fluid>
                    <div>
                    <SyncButton load={load} color={envColor} />
                    <FilterButton load={setSqlMenu} color={envColor} />
                        <Input icon='search' iconPosition='left' style={{width: '500px'}}>
                        <Icon name='search' />
                            <input
                                id='objectId'
                                placeholder={
                                    (filterRef.current.length!==0)?
                                    ((filterRef.current[0].value==='')? 'Search for SIC (e.g. PV204150)': filterRef.current[0].value): 'Search for SIC (e.g. PV204150)'
                                }
                                style={{ borderRadius: '100px' }}
                                onChange={({ target: { value } }) => onFieldChange('sic', value)}
                                onKeyUp={keyPress}
                                onClick={(value) => forceFilterRead('sic', value)}
                            />

                        </Input>
                    </div>

                    {filtersModal &&
                        <SqlFiltersWindow
                        onRestore={onFC.bind(this)}
                        onClose={setSqlMenu.bind(this)}
                        onForm={onFormChange.bind(this)}
                        onApply={apply.bind(this)}
                        />
                     }

                    {form &&
                    renderForm()
                     }

                    {loading ?
                        <Dimmer inverted active={true}><Loader/></Dimmer> :
                        <>
                            <Table definition rows={events ?? []}>
                                {get_cells()}
                            </Table>
                            <Pagination
                                activePage={activePage}
                                totalPages={totalPages}
                                onPageChange={setActivePage}
                            />
                        </>
                    }
                </Container>
            </Segment>
        </div>
    );
};

export default Statistics;